import { createFileRoute } from '@tanstack/react-router'
import { generateMetaTags } from '@/lib/seo'

export const Route = createFileRoute('/admin')({
  head: () => ({
    meta: generateMetaTags({
      title: 'Admin - ModelStack',
      description: 'Internal administration tools for the ModelStack platform.',
      noindex: true,
      nofollow: true,
    }),
  }),
})
